import React from 'react'

const Features = ({ 
  plans 
}) => {
 
  const createPlanFees = (plans) => {
  
    const names = [plans[0]].map((plan, key) => {
      
      const planFees = plan.planFees.map((data, key) => {
        
        return (
          <tr>
            <td> { data.displayName } <div className="pricing-table-info"> { data.description } </div> </td>
            { plans.map((item, key) => {
              return (
                item.planFees.find(item => item.displayName === data.displayName) ? <td key={key}> ${ item.planFees.find(item => item.displayName === data.displayName).amount } </td> : <td> - </td> 
              )
            })}
          </tr>
        )
      })

      return planFees
    });

    return names    
  }

  const createStorageFees = (plans) => {

    const names = [plans[0]].map((plan, key) => {
      
      const storage = plan.storage.map((data, key) => {
        
        return (
          <tr>
            <td> { data.displayName } <div className="pricing-table-info"> { data.description } </div> </td>
            { plans.map((item, key) => {
              return (
                item.storage.find(item => item.displayName === data.displayName) ? <td key={key}> ${ item.storage.find(item => item.displayName === data.displayName).amount } </td> : <td key={key}> - </td> 
              )
            })}
          </tr>
        )
      })

      return storage
    });

    return names    
  }

  const createPlanRules = (plans) => {
    const names = [plans[0]].map((plan, key) => {
      
      const planRules = plan.planRules.map((data, key) => {
        
        return (
          <tr>
            <td> { data.displayName } <div className="pricing-table-info"> { data.description } </div> </td>
            { plans.map((item, key) => {
              return (
                item.planRules.find(item => item.name === data.name) ? <td key={key}> { item.planRules.find(item => item.name === data.name).enabled ? <div className="pricing-check"> <i><svg className="feather"><use href="/assets/images/icons/feather-sprite.svg#check"/></svg></i> </div> : <div> - </div> } </td> : null
              )
            })}
          </tr>
        )
      })

      return planRules
    });

    return names    
  }

  return (
    <div>
      <div>
        <div>
          <section >
              <div className="row">
                  <div>
                    <div>
                      <table className="pricing-table">
                          <thead>
                            <tr>
                              <th></th>
                              {
                                plans.map((plan, key) => {
                                  return (
                                    <th key={key}> { plan.planName } </th>
                                  )
                                })
                              }
                            </tr>
                          </thead>
                          <tbody>
                              <tr className="pricing-table-title">
                                <td colSpan="6">
                                    Pricing
                                </td>
                              </tr>
                              {
                                createPlanFees(plans)
                              }
                              <tr className="pricing-table-title">
                                <td colSpan="6">
                                    Services
                                </td>
                              </tr>
                              {
                                createPlanRules(plans)
                              }
                              <tr className="pricing-table-title">
                                <td colSpan="6">
                                    Storage (cost per day)
                                </td>
                              </tr>
                              {
                                createStorageFees(plans)
                              }
                          </tbody>
                      </table>
                    </div>
                  </div>
              </div>
          </section>
        </div>
    </div>
  </div>
  )
}

export default Features